module.exports = __webpack_public_path__ + "static/media/B1.1cc9a2de.jpg";